import { StateCreator } from 'zustand';

export interface ExamSlice {
  currentAnswersSheet: Record<string, any>;
  updateAnswersSheet: (answers: Record<string, any>) => void;
}

export const createExamSlice: StateCreator<ExamSlice> = (set, get) => ({
  currentAnswersSheet: {},
  updateAnswersSheet: (answers) =>
    set(() => ({
      currentAnswersSheet: answers,
    })),
});
